// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-styles[data-v-255da780]{width:14px;height:14px}.padding-title[data-v-255da780]{padding-bottom:30px}.padding-button[data-v-255da780]{padding-top:80px}", ""]);
// Exports
module.exports = exports;
